import React from 'react';
import KnowledgeRecord from './knowledgeRecord';
import PageControllBar from './PageControllBar';
const KnowledgeForm = ({
    title,
    knowledgeToShow,
    rowPerPage,
    firstIndexOfShown,
    handleSelectRowPerPageChange,
    handleSetPage,
}) => {
    return (
        <>
            <h2 style={{ margin: '50px 10px 50px' }}>{title}</h2>
            <hr style={{ border: 'solid 1px #000000' }}></hr>

            {knowledgeToShow
                .flat()
                .slice(firstIndexOfShown, firstIndexOfShown + rowPerPage)
                .map((article) => {
                    const {
                        title,
                        description_file_path,
                        description_file_name,
                        description_text,
                        knowledge_base_id,
                        video_url,
                    } = article;
                    return (
                        <div style={{ margin: '12px 0px' }} key={'knowledge_base_id_' + knowledge_base_id}>
                            <KnowledgeRecord
                                title={title}
                                description={description_text}
                                link={description_file_path || video_url}
                                name={description_file_name}
                            />
                        </div>
                    );
                })}
            <PageControllBar
                title={title}
                rowPerPage={rowPerPage}
                firstIndexOfShown={firstIndexOfShown}
                knowledgeToShow={knowledgeToShow}
                handleSelectRowPerPageChange={handleSelectRowPerPageChange}
                handleSetPage={handleSetPage}
            />
        </>
    );
};

export default KnowledgeForm;
